<template>
  <div class="index-wrapper">
    <div class="container">
      <div class="header"></div>
      <div class="content">
        <div class="introduce">
          <p>欢迎来到昆曲世界</p>
          <p>开启一场与嫣红姹紫的旅程</p>
          <p class="title">想要了解您所对应的昆曲形象吗？</p>
        </div>
        <div class="gender-select">
          <div class="tip">请先选择您的性别</div>
          <div class="gender">
            <div
              class="gender-item female"
              :class="{ active: selectGender == 'FEMALE' }"
              @click="handleSelectGender('FEMALE')"
            >
              <div class="content">
                <img src="@/assets/imgs/female.png" class="female-icon" />
                <!-- <i class="iconfont icon-xingbienv" /> -->
              </div>
            </div>
            <div
              class="gender-item male"
              :class="{ active: selectGender == 'MALE' }"
              @click="handleSelectGender('MALE')"
            >
              <div class="content">
                <img src="@/assets/imgs/male.png" class="male-icon" />
                <!-- <i class="iconfont icon-xingbienan" /> -->
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="footer">
        <TestStartButton
          label="开始测试"
          @click="goTest"
          class="start-button"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, nextTick, onMounted, onBeforeUnmount } from "vue";
import { useRouter, useRoute } from "vue-router";
// import initWx from "@/utils/weixin.config";
import TestStartButton from "@/components/TestStartButton.vue";

const router = useRouter();

const selectGender = ref("");
const handleSelectGender = (type) => {
  selectGender.value = type;
};

//前往测试
const goTest = () => {
  if (selectGender.value) {
    router.replace({
      name: "Test",
      params: {
        gender: selectGender.value,
      },
    });
  } else {
  }
};

onMounted(() => {
  // initWx();
});
</script>

<style lang="scss" scoped>
$header-height: 100px;
$footer-height: 200px;
.index-wrapper {
  height: 100vh;
  background-color: #ffffff;
  overflow: hidden;
  .container {
    width: 100%;
    height: 100%;
    position: relative;
    .header {
      width: 100%;
      height: $header-height;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .content {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-around;
      height: calc(100% - $header-height - $footer-height);
      .introduce {
        font-size: 18px;
        line-height: 40px;
        color: $font-color;
        .title {
          color: $font-color;
          font-size: 20px;
          margin-top: 40px;
          font-weight: 550;
        }
      }
      .gender-select {
        .tip {
          color: $font-color;
          margin-bottom: 30px;
          font-size: 15px;
        }
        .gender {
          display: flex;
          gap: 30px;
          .gender-item {
            width: 135px;
            height: 135px;
            background-color: #ffffff;
            border-radius: 10px;
            cursor: pointer;
            box-shadow: 0px 2px 10px -5px rgba(132, 132, 134, 0.4);
            transition: transform 0.4s ease;
            .content {
              width: 100%;
              height: 100%;
              display: flex;
              justify-content: center;
              align-items: center;
              transition: transform 0.4s ease;
              .iconfont {
                transition: transform 0.4s ease;
              }
            }
          }
          .gender-item:hover {
            cursor: pointer;
            transform: scale(0.97);
          }

          .gender-item:hover .content {
            transform: scale(0.96);
          }

          .gender-item:hover .iconfont {
            transform: scale(1.05);
          }

          .gender-item:active {
            transform: scale(0.9);
          }
          .active {
            background-color: #f5f2eb;
            box-shadow: 0px 2px 10px -5px rgba(132, 132, 134, 0.4);
          }
          .female {
            .female-icon {
              width: 75px;
            }
            .iconfont {
              color: #e5d3ab;
              font-size: 60px;
            }
          }
          .female:hover {
            box-shadow: 0px 2px 10px -5px rgba(132, 132, 134, 0.4);
          }
          .male.active {
            background-color: #e9eddf;
          }
          .male {
            .male-icon {
              width: 70px;
            }
            .iconfont {
              color: #c9cfc3;
              font-size: 60px;
            }
          }
          .male:hover {
            box-shadow: 0px 2px 10px -5px rgba(132, 132, 134, 0.4);
          }
        }
      }
    }
    .footer {
      width: 100%;
      position: absolute;
      bottom: 0px;
      height: $footer-height;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}
:deep(.el-carousel__indicators) {
  bottom: 30px;
  .el-carousel__indicator {
    .el-carousel__button {
      width: 13px;
      height: 4px;
      opacity: 1;
      background-color: #ffffff;
      border-radius: 3px;
    }
  }
  .is-active {
    .el-carousel__button {
      background-color: $theme-color;
    }
  }
}
.introduce p {
  opacity: 0;
}
.gender-select,
.start-button {
  opacity: 0;
}
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.introduce p:nth-child(1) {
  animation: fadeIn 1s ease forwards 0.5s;
}
.introduce p:nth-child(2) {
  animation: fadeIn 1s ease forwards 1s;
}
.introduce p:nth-child(3) {
  animation: fadeIn 1s ease forwards 1.5s;
}
.gender-select,
.start-button {
  animation: fadeIn 1s ease forwards 2s;
}
</style>
